module.exports = __webpack_public_path__ + "img/big_1_74.e2df2c4d.png";